export default "__VITE_ASSET__BxmAFmsv__"